import { CUSTOM_ELEMENTS_SCHEMA, Component, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { IHeader } from 'app/interfaces';
import { HomeService } from '../../services/home.service';
import { TabList } from '@upmc-healthplan-npm/ods-wc';
import { Subject, takeUntil } from 'rxjs';
import { FLU_CAMPAIGN_ID, COVID_CAMPAIGN_ID } from 'app/shared/constants/campaign-constants';

import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterOutlet, SharedModule, FormsModule],
  providers: [HomeService],
})
export class HomePageComponent implements OnInit, OnDestroy {
  public isFluEnabled: boolean = true;
  public isHomeRoute: boolean = true;
  public username: string = '';
  public fluHeader: IHeader | null = null;
  public covidHeader: IHeader | null = null;
  public showTitle: boolean = true;
  public selectedCapmaign: number = FLU_CAMPAIGN_ID;
  private campaignMap: Array<string> = ['flu', 'covid'];
  @ViewChild('tabList') tabList: ElementRef<TabList> | null = null;
  private router: Router = inject(Router);
  private homeService: HomeService = inject(HomeService);
  private destroy$ = new Subject<void>();
  readonly FLU_CAMPAIGN_ID = FLU_CAMPAIGN_ID;
  readonly COVID_CAMPAIGN_ID = COVID_CAMPAIGN_ID;
  selectedTabId: number = this.FLU_CAMPAIGN_ID;

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.selectedCapmaign = this.homeService.getActiveCampaign();
    this.selectedTabId = this.selectedCapmaign;
    this.homeService.setActiveCampaign(this.campaignMap[this.selectedCapmaign - 1]);
    this.homeService.fetchProgramSummary(this.selectedCapmaign);
    this.showTitle =
      this.router.url.indexOf('assessments') < 0 && this.router.url.indexOf('documents') < 0 && this.router.url.indexOf('/info') < 0;

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe({
      next: (event) => {
        if (event instanceof NavigationEnd) {
          this.showTitle = event.url.indexOf('assessments') < 0 && event.url.indexOf('documents') < 0 && event.url.indexOf('/info') < 0;
          if (event.url.indexOf('/home/') < 0 && event.url.indexOf('/home') >= 0) {
            this.reload();
          }
        }
      },
    });

    this.homeService.fluHeader.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data) => {
        this.fluHeader = data;
      },
    });

    this.homeService.covidHeader.pipe(takeUntil(this.destroy$)).subscribe({
      next: (data) => {
        this.covidHeader = data;
      },
    });
  }

  onTabClick(event: MouseEvent, tabId: number): void {
    event.preventDefault();
    this.selectedTabId = tabId;
    this.setActiveCampaign(tabId);
  }

  get selectedTab(): string {
    if (this.tabList) {
      this.tabList.nativeElement.selected = String(this.selectedCapmaign);
    }

    return String(this.selectedCapmaign);
  }

  reload() {
    this.homeService.fetchProgramSummary(this.selectedCapmaign);
  }

  setActiveCampaign(tabId: number) {
    this.selectedCapmaign = tabId;
    this.homeService.setActiveCampaign(this.campaignMap[this.selectedCapmaign - 1]);
    this.isFluEnabled = this.selectedCapmaign === FLU_CAMPAIGN_ID;
    this.homeService.fetchProgramSummary(this.selectedCapmaign);
  }
}
